// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"sQ1elS","content":"_wMcD3","vertical":"De2Mcn","title":"iHmoAp"};